module.exports = __webpack_public_path__ + "img/bacias.bd219b03.png";